import { OpenQuestionPinSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { PinBackground } from '../components/PinBackground';

export interface OpenQuestionPinProps {
  pinSettings: OpenQuestionPinSettings;
  isThumb?: boolean;
  children?: React.ReactNode;
}

export const OpenQuestionPinComponent: React.FC<OpenQuestionPinProps> = ({ pinSettings, isThumb, children }) => {
  return (
    <OpenQuestionWrapper>
      <PinBackground pinType="OPEN_QUESTION" settings={pinSettings} isThumb={isThumb} />
      {children}
    </OpenQuestionWrapper>
  );
};

const OpenQuestionWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;
